import { formatPhoneNumberIntl } from 'react-phone-number-input';

export function formatDisplayPhone(phone: string | null | undefined): string {
  if (!phone) return '';
  const phoneWithPlus = phone.startsWith('+') ? phone : `+${phone}`;
  return formatPhoneNumberIntl(phoneWithPlus) || phoneWithPlus;
}

export function phoneTelHref(phone: string | null | undefined): string {
  if (!phone?.trim()) return '';
  const normalized = phone.trim().startsWith('+') ? phone.trim() : `+${phone.trim()}`;
  return `tel:${normalized}`;
}

export function whatsappPhoneHref(phone: string | null | undefined): string {
  if (!phone?.trim()) return '';
  const digits = phone.replace(/\D/g, '');
  return digits ? `https://wa.me/${digits}` : '';
}
